import React from "react";
import { Badge } from "@shopify/polaris";

export function RecommendationStatus({ enabled }: { enabled: boolean | number }) {
    return (
        <Badge tone={enabled == 1 ? "success" : "info"}>
            {enabled == 1 ? "Active" : "Inactive"}
        </Badge>
    );
}
